import React from 'react'
import SpotifyIcon from '../img/spotify.png';

export const SpotifyIconSmall = (props) => {

  return (
    <a href="https://open.spotify.com/" target="_blank" rel="noreferrer" ><img alt="Spotify" style={{height: '21px'}} src={SpotifyIcon} /></a>
              )
}